module.exports = __webpack_public_path__ + "static/img/build2.3deff6d3.jpeg";